import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchBrandList = params => api.request(1, '/brands', MethodType.GET, params)

export const fetchBrand = (id, params) => api.request(1, `/brands/${id}`, MethodType.GET, params)

export const addBrand = params => api.request(1, '/brands', MethodType.POST, params)

export const modifyBrand = (id, params) => api.request(1, `/brands/${id}`, MethodType.PUT, params)

export const deleteBrand = (id, params) => api.request(1, `/brands/${id}`, MethodType.DELETE, params)

export const fetchDataSource = params => api.request(1, '/dataSources', MethodType.GET, params)

// brand user list
export const fetchBrandUserList = params => api.request(1, '/brandUsers', MethodType.GET, params)

export const addBrandUser = params => api.request(1, '/brandUsers', MethodType.POST, params)

export const editBrandUser = (brandId, userId, params) => api.request(1, `/brandUsers/${brandId}/${userId}`, MethodType.PATCH, params)

export const deleteBrandUser = (brandId, userId, params) => api.request(1, `/brandUsers/${brandId}/${userId}`, MethodType.DELETE, params)

export const quitAllBrands = (groupId, userId, params) => api.request(1, `/userQuitAllBrands/${groupId}/${userId}`, MethodType.DELETE, params)
